const VISITOR_COOKIE = 'apt_provider_visitor_id';
const SESSION_KEY = 'apt_provider_acquisition_session';

function randomId(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `v_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

function readCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string, maxAgeSeconds: number): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAgeSeconds}; SameSite=Lax`;
}

/** Stable anonymous visitor id for provider acquisition frequency caps. */
export function getOrCreateProviderVisitorId(): string {
  const existing = readCookie(VISITOR_COOKIE);
  if (existing && existing.length >= 8) {
    return existing;
  }
  const id = randomId();
  writeCookie(VISITOR_COOKIE, id, 365 * 24 * 60 * 60);
  return id;
}

export function getProviderAcquisitionSessionId(): string {
  if (typeof sessionStorage === 'undefined') {
    return randomId();
  }
  let sessionId = sessionStorage.getItem(SESSION_KEY);
  if (!sessionId) {
    sessionId = randomId();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }
  return sessionId;
}

export function markProviderCampaignShownThisSession(campaignId: number): void {
  if (typeof sessionStorage === 'undefined') return;
  sessionStorage.setItem(`apt_provider_popup_shown_${campaignId}`, '1');
}

export function wasProviderCampaignShownThisSession(campaignId: number): boolean {
  if (typeof sessionStorage === 'undefined') return false;
  return sessionStorage.getItem(`apt_provider_popup_shown_${campaignId}`) === '1';
}
